import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { catchError, debounceTime, map, Observable, of, switchMap } from "rxjs";
import { MoodleWebService } from "../services/moodle-web.service";

@Injectable({ providedIn: "root" })
export class AsyncEmailValidator {

    constructor(private http: HttpClient, private moodle: MoodleWebService) {}

  checkEmailExists(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      // Return null for empty values (valid by default)
      if (!control.value) {
        
        return of(null);
      }

      return of(control.value).pipe(
        // Delay processing to debounce user input
        debounceTime(500),
        // Cancel previous requests and switch to the latest
        switchMap((email) =>
          this.moodle.getUserByEmail(email).pipe(
            // If the API returns data, emit { emailExists: true }; otherwise null
            map((response) => {return (response?.length > 0 ? { emailExists: true } : null)}),
            // Handle errors (e.g., network issues)
            catchError(() => of(null))
          )
        )
      );
    }
  }
}